module.exports = ".code-status {\n   height: 20px;\n   table-layout: fixed;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/business-units/development/development.component.css
// module id = ./src/app/web/game/management/business-units/development/development.component.css
// module chunks = main